import React from 'react'

import { useWhatsappSupport } from '../../hooks/use-whatsapp-support'

import { StyledLink } from './StyledLink'

// Whatsapp customer support link
// Origin of the feature: https://cardohealth.atlassian.net/browse/CAR-3218
export const WhatsappSupportLink = () => {
  const { whatsappUrlWithIntro } = useWhatsappSupport()

  if (!whatsappUrlWithIntro) {
    console.warn('WhatsappSupportLink: whatsappUrlWithIntro is not defined')
    return null
  }

  return (
    <StyledLink href={whatsappUrlWithIntro} target="_blank">
      WhatsApp
    </StyledLink>
  )
}
